import { call, put } from 'redux-saga/effects';
import api from '../Api/user';
import {  loginSuccessAction} from '../Actions/UserActions';

export function* userLoginSaga(action) {
    const user = yield call(api.user.login, action.payload);
    yield put(loginSuccessAction(user));
}



// WEBPACK FOOTER //
// ./src/Sagas/userSagas.js